// src/calculators/law.js — страничната колона „Кога се използва / Какво казва
// законът" на калкулаторите. Изнесена от labor2.js (задача 4/6), за да я
// ползват и новите калкулатори (Наем, чл. 55) БЕЗ копие — две копия на
// колоната неизбежно се разминават при следващата промяна на оформлението.

import { el } from '../shared/dom.js';

// Предупреждението за законната лихва (ПМС № 426/2014: ЕЦБ + 8 пункта) — едно
// за „Законна лихва" и „Промяна на авансовите вноски", за да не се разминат.
export const ECB_RATE_WARNING = '⚠ Проверете лихвения процент на ЕЦБ (обнародван в „Официален вестник" на ЕС; публикува го и БНБ) и добавете 8 пункта — подразбиращото се „8" предполага ЕЦБ = 0.';

// law = { when: ['случай…'], quotes: [{ ref: 'чл. …', text: 'дословният текст' }] }
export function lawSide(law) {
  return el('aside', { class: 'calc-law' },
    el('h4', { text: 'Кога се използва' }),
    el('ul', {}, ...law.when.map((w) => el('li', { text: w }))),
    el('h4', { text: 'Какво казва законът' }),
    ...law.quotes.map((q) => el('div', { class: 'law-quote' },
      el('div', { class: 'law-ref', text: q.ref }),
      el('blockquote', { text: '„' + q.text + '"' }))));
}

// Панел + колона, подредени от .calc-with-law (на тесен екран колоната пада отдолу).
export const withLaw = (panel, law) => el('div', { class: 'calc-with-law' }, panel, lawSide(law));

// ---- Цитат при полето (задача 6/6) ----
//
// Малка иконка „§" до етикета на поле: при клик/Enter показва члена и
// правилото В ЕДИН РЕД под етикета; Escape затваря. Истински <button> с
// aria-describedby (екранният четец чете правилото и без да „отваря"),
// не <span> с onClick — иначе клавиатурата не стига до него.
let _hintSeq = 0;

export function lawHint(ref, text) {
  const id = 'law-hint-' + (++_hintSeq);
  const tip = el('span', { class: 'law-hint-tip', id, role: 'note', text: ref + ' — ' + text });
  tip.hidden = true;
  const btn = el('button', {
    type: 'button', class: 'law-hint-btn',
    'aria-describedby': id, 'aria-expanded': 'false',
    'aria-label': 'Правно основание: ' + ref,
    text: '§',
  });
  function setOpen(open) {
    tip.hidden = !open;
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  }
  btn.addEventListener('click', (e) => {
    // Иконката живее ВЪТРЕ в <label> — без това кликът активира етикета
    // и фокусът скача в полето, вместо да се покаже правилото.
    e.preventDefault();
    e.stopPropagation();
    setOpen(tip.hidden);
  });
  btn.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && !tip.hidden) { e.preventDefault(); setOpen(false); }
  });
  return el('span', { class: 'law-hint' }, btn, tip);
}

// Закача lawHint към ЕТИКЕТА на поле, направено с field() от shared/dom.js.
// Връща същия елемент — ползва се на място: hintify(field('…', inp), ref, text).
export function hintify(fieldEl, ref, text) {
  const lbl = fieldEl.querySelector('label');
  (lbl || fieldEl).appendChild(lawHint(ref, text));
  return fieldEl;
}
